import { call, put, select, takeLatest } from 'redux-saga/effects';

import { getAllInstruments } from '!core/redux/userInstruments/userInstruments.selectors';
import { securityAccountSelectedSelector } from '!core/redux/userSecuritiesAccounts/userSecuritiesAccounts.selectors';
import { webAreasServices } from '!views/Market/redux/webAreas/webAreas.services';
import { handleSagaError } from '»utils/handleSagasError';
import { joinChartsData } from '»utils/joinChartsData';

import { fundsServices } from './funds.services';
import { fundsSlice } from './funds.slice';

const fundsInfoWorker = function* ({ payload }) {
  try {
    const fundsData = yield call(fundsServices.fundsInfo, {
      securityType: payload.securityType,
      securityExchange: payload.securityExchange,
    });

    const securityAccount = yield select(securityAccountSelectedSelector);
    const userInstruments = yield select(getAllInstruments);

    const fundsAdditionalData = yield call(
      webAreasServices.webAreaInstrQuotes,
      {
        account: securityAccount,
        webPage: 'FUNDS',
        webArea: payload.webAreaId,
      },
    );

    const respElementIndex = fundsAdditionalData.findIndex(
      (el) => el.type === 'resp',
    );

    fundsAdditionalData.splice(respElementIndex, respElementIndex >= 0 ? 1 : 0);

    let fundsFullData = mergeFundsData(
      fundsData,
      fundsAdditionalData,
      userInstruments,
    );

    if (payload.getCharts) {
      const charts = yield call(webAreasServices.webAreaGraphQuotes, {
        account: securityAccount,
        webPage: 'FUNDS',
        webArea: payload.webAreaId,
      });

      fundsFullData = joinChartsData(fundsFullData, charts);
    }

    yield put(
      fundsSlice.actions.fundsInfoSuccess({
        securityType: payload.securityType,
        securityExchange: payload.securityExchange,
        fundsList: fundsFullData,
      }),
    );
  } catch (error) {
    const handled = yield call(handleSagaError, error);
    if (!handled)
      yield put(
        fundsSlice.actions.fundsInfoFailure({
          securityType: payload.securityType,
          securityExchange: payload.securityExchange,
        }),
      );
  }
};

const mergeFundsData = (fundsData, fundsAdditionalData, userInstruments) => {
  const newFundsData = [];
  fundsData.forEach((value) => {
    const newFields = fundsAdditionalData.find(
      (field) =>
        field.securityType === value.securityType &&
        field.symbol === value.symbol &&
        field.exchange === value.securityExchange,
    );

    newFundsData.push({ ...newFields, ...value });
  });

  const isMarketFundsManager = fundsData[0]?.securityType === 'FUND';

  if (isMarketFundsManager)
    for (let fund = 0; fund < newFundsData.length; fund++) {
      const instrumentData = userInstruments.find(
        (instrument) =>
          instrument.securityType === newFundsData[fund].securityType &&
          instrument.symbol === newFundsData[fund].symbol &&
          instrument.exchange === newFundsData[fund].exchange,
      );

      if (instrumentData)
        newFundsData[fund] = { ...newFundsData[fund], ...instrumentData };
    }

  return newFundsData;
};

export const fundsSagas = function* () {
  yield takeLatest(fundsSlice.actions.fundsInfoRequest.type, fundsInfoWorker);
};
